import ExpansionPanel from '@natera/platform/lib/components/expansionPanel'
import type { ExpansionPanelProps } from '@natera/platform/lib/components/expansionPanel/expansionPanel'
import { cn } from '~/shared/lib/cn'
import { Tooltip } from '~/shared/ui/local-tooltip'
import './expansion-panel-filter.scss'

interface ExpansionPanelFilterProps extends ExpansionPanelProps {
  withIndicator?: boolean
  disabled?: boolean
  disabledTooltip?: string
}

export function ExpansionPanelFilter({
  children,
  className,
  withIndicator = false,
  disabled = false,
  disabledTooltip,
  ...props
}: ExpansionPanelFilterProps) {
  const panelContent = (
    <ExpansionPanel
      className={cn(
        'c-expansion-panel-filter',
        { 'c-expansion-panel-filter--disabled': disabled },
        className,
      )}
      materialArrowIcon="keyboard_arrow_down"
      {...props}
      defaultExpanded={disabled ? false : props.defaultExpanded}
      disabled={disabled}
    >
      {withIndicator && (
        <div className="bg-primary-main absolute top-1.5 right-4.5 h-2 w-2 rounded-full" />
      )}
      {children}
    </ExpansionPanel>
  )

  if (disabled && disabledTooltip) {
    return (
      <Tooltip content={disabledTooltip}>
        <div>{panelContent}</div>
      </Tooltip>
    )
  }

  return panelContent
}
